import {
  buildJanelaRequest,
  createInitialJanela,
  janelaRequestToValues,
  parseJanelaValor,
} from "@/modules/recursos";
import type { JanelaBlocoValues, PapelObra } from "@/modules/recursos";

import { FIELD_REQUIRED_MESSAGE, VALOR_INVALID_MESSAGE } from "./papel-obra-form-dialog.constants";
import type {
  PapelObraFormField,
  PapelObraFormState,
  PapelObraFormValues,
} from "./types-papel-obra-form-dialog";

export function toFormState(papel?: PapelObra): PapelObraFormState {
  const janela = papel ? janelaRequestToValues(papel.janela) : createInitialJanela();

  return {
    nome: papel?.nome ?? "",
    obrigatorio: papel?.obrigatorio ?? true,
    entrada: janela.entrada,
    saida: janela.saida,
  };
}

/** Bloco marcado não tem valor; desmarcado exige um inteiro >= 0. */
function valorError(bloco: JanelaBlocoValues): string | undefined {
  if (bloco.marcado) return undefined;
  if (bloco.valor.trim() === "") return FIELD_REQUIRED_MESSAGE;

  return parseJanelaValor(bloco.valor) === null ? VALOR_INVALID_MESSAGE : undefined;
}

/** Erros por campo; a janela só vale para papel obrigatório (RN 2034). */
export function validatePapelObraForm(
  state: PapelObraFormState,
): Partial<Record<PapelObraFormField, string>> {
  const errors: Partial<Record<PapelObraFormField, string>> = {};

  if (state.nome.trim() === "") errors.nome = FIELD_REQUIRED_MESSAGE;
  if (state.obrigatorio) {
    const entrada = valorError(state.entrada);
    const saida = valorError(state.saida);
    if (entrada) errors.entrada = entrada;
    if (saida) errors.saida = saida;
  }

  return errors;
}

export function toPapelObraFormValues(state: PapelObraFormState): PapelObraFormValues {
  return {
    nome: state.nome.trim(),
    obrigatorio: state.obrigatorio,
    ...(state.obrigatorio
      ? { janela: buildJanelaRequest({ entrada: state.entrada, saida: state.saida }) }
      : {}),
  };
}
